/**
 * 夜間相談チャットにおける「担当者一致」判定ロジック。
 *
 * 追加のAPI通信を一切行わない純粋関数として実装する。
 */

export type ResponsibleJudgeParams = {
  /** hasAllCapabilities(["operator:access"]) の結果 */
  isOperator: boolean;
  /** GET /api/v1/reservations/:id レスポンスの shiftDoctorId */
  shiftDoctorId: number | null | undefined;
  /** ログイン中相談員の currentDoctor.id */
  currentDoctorId: number | null | undefined;
};

/**
 * 担当者一致判定。
 * 「担当内(true)」を返した場合のみ、バナー非表示・確認ダイアログ省略の対象となる。
 *
 * 判定順序:
 *   1. isOperator が true なら常に true（operatorロールは最優先でバイパス）
 *   2. shiftDoctorId が null/undefined なら false（シフト未設定は担当外扱い）
 *   3. currentDoctorId が null/undefined なら false（安全側で担当外扱い）
 *   4. currentDoctorId === shiftDoctorId で通常判定
 *
 * ※ ロール取得失敗時のフォールバックは、
 *    呼び出し側の hasAllCapabilities が capabilities 未取得時に false を返すことで、
 *    isOperator=false として自然に通常判定へフォールバックするため、
 *    本関数内で例外的な分岐を新設する必要はない。
 */
export function isResponsibleDoctor({
  isOperator,
  shiftDoctorId,
  currentDoctorId,
}: ResponsibleJudgeParams): boolean {
  if (isOperator) return true;

  if (shiftDoctorId == null) return false;

  if (currentDoctorId == null) return false;

  return currentDoctorId === shiftDoctorId;
}
